import React from 'react';

class GridSelect extends React.Component {
  constructor(props) {
    super(props);
    const option = this.props.option;
    const defaultValue = this.props.defaultvalue;
    option.map((item) => {
      item.isChecked = false;
      if (this.props.multiselect === 'false' && item.key === this.props.defaultvalue[0]) {
        item.isChecked = true;
      }
    });
    if (this.props.multiselect === 'true') {
      defaultValue.map((defaultitem) => {
        option.map((item, index) => {
          if (item.key === defaultitem) {
            option[index].isChecked = true;
          }
        });
      });
    }
    this.state = {
      option,
    };
  }
  handleImageSelect(e) {
    const option = this.state.option;
    if (this.props.multiselect === 'false') {
      option.map((item) => {
        if (item.key === e.target.id) {
          item.isChecked = !item.isChecked;
          if (item.isChecked === true) {
            this.props.onImageSelcted(e.target.id, 'false');
          }
        } else {
          item.isChecked = false;
        }
      });
    } else {
      option.map((item) => {
        if (item.key === e.target.id) {
          item.isChecked = !item.isChecked;
          this.props.onImageSelcted(e.target.id, 'true');
        }
      });
    }
    this.setState({ option });
  }
  render() {
    const singleImage = (item) => {

      return (
        <span className="search-content" key= {item.key}>
          <input type = "checkbox" checked={item.isChecked} id= { item.key } value= {item.key} onChange = {this.handleImageSelect.bind(this)} />
          <label className="select-search-content" htmlFor= { item.key }>{ item.gridName }</label>
        </span>
        );
    };
    return (
      <span className="checkbox-input-content">
        { this.state.option.map(singleImage)}
      </span>
    );
  }
}

GridSelect.propTypes = {
  'multiselect': React.PropTypes.string,
  'option': React.PropTypes.array,
  'defaultvalue': React.PropTypes.array,
};

export default GridSelect;



// WEBPACK FOOTER //
// ./assets/src/frontend/element/gridselect.js